exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-md-2[data-v-c62d4612] {\n    flex: 0 0 20%;\n    max-width: 20%;\n}\n.payroll-counter-box .top-box[data-v-c62d4612] {\n    border: none;\n}\n", ""]);

// exports
